import React from 'react';
import { Navbar, Nav, Container, Button, Row, Col, Card, Image } from 'react-bootstrap';
import { FaTrash, FaTruck, FaSmile, FaRegStar, FaStar } from 'react-icons/fa';

// Main Landing Page Component
const EasyTrashOutLandingPage_10_06_2025: React.FC = () => {
    return (
        <>
            {/* 1. Navigation Bar */}
            <Navbar bg="light" expand="lg" sticky="top" className="shadow-sm">
                <Container>
                    <Navbar.Brand href="#home" className="fw-bold text-success">
                        <FaTrash className="me-2" />
                        EasyTrashOut.com
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ms-auto">
                            <Nav.Link href="#features">Features</Nav.Link>
                            <Nav.Link href="#how-it-works">How It Works</Nav.Link>
                            <Nav.Link href="#testimonials">Testimonials</Nav.Link>
                        </Nav>
                        <Button variant="outline-success" className="ms-lg-3">Request a Pickup</Button>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            {/* 2. Hero Section */}
            <Container fluid="md" className="text-center my-5 p-5 bg-light rounded-3">
                <h1 className="display-4 fw-bold">Junk Removal, Made Simple.</h1>
                <p className="lead col-lg-8 mx-auto">
                    Say goodbye to clutter. EasyTrashOut.com provides fast, reliable, and eco-friendly junk removal services for your home or business.
                </p>
                <Button variant="success" size="lg" className="mt-3">
                    Get Your Free Quote Today!
                </Button>
            </Container>

            {/* 3. Features Section */}
            <Container id="features" className="py-5">
                <h2 className="text-center mb-5">Why Choose Us?</h2>
                <Row xs={1} md={3} className="g-4">
                    <Col>
                        <Card className="text-center h-100 border-0 shadow-sm">
                            <Card.Body>
                                <FaTruck size={40} className="text-success mb-3" />
                                <Card.Title>Same-Day Service</Card.Title>
                                <Card.Text>
                                    Need it gone now? We offer same-day pickup to clear your space on your schedule.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card className="text-center h-100 border-0 shadow-sm">
                            <Card.Body>
                                <Card.Title>Eco-Friendly Disposal</Card.Title>
                                <Card.Text>
                                    We prioritize recycling and donating your items to minimize landfill waste.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card className="text-center h-100 border-0 shadow-sm">
                            <Card.Body>
                                <FaSmile size={40} className="text-success mb-3" />
                                <Card.Title>Transparent Pricing</Card.Title>
                                <Card.Text>
                                    No hidden fees. Get a free, no-obligation quote upfront before we start any work.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>

            {/* 4. How It Works Section */}
            <Container id="how-it-works" className="py-5 bg-light rounded-3">
                <h2 className="text-center mb-5">Get Started in 3 Easy Steps</h2>
                <Row className="text-center">
                    <Col md={4}>
                        <div className="p-3">
                            <h3 className="text-success">1. Book Online</h3>
                            <p>Select a pickup time and tell us what you need removed. It only takes a few minutes.</p>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="p-3">
                            <h3 className="text-success">2. We Pick Up</h3>
                            <p>Our friendly, professional team arrives on time, and you just point to the junk you want gone.</p>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="p-3">
                            <h3 className="text-success">3. We Haul Away</h3>
                            <p>We do all the heavy lifting and sweep up afterward, leaving you with a clean, clutter-free space.</p>
                        </div>
                    </Col>
                </Row>
            </Container>

            {/* 5. Testimonials Section */}
            <Container id="testimonials" className="py-5">
                <h2 className="text-center mb-5">What Our Customers Say</h2>
                <Row>
                    <Col md={6} lg={4} className="mb-4">
                        <Card className="h-100">
                            <Card.Body>
                                <div className="d-flex align-items-center mb-3">
                                    <Image src="https://i.pravatar.cc/50?img=1" roundedCircle className="me-3" />
                                    <div>
                                        <Card.Title className="mb-0">Sarah J.</Card.Title>
                                        <div className="text-warning">
                                            <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                                        </div>
                                    </div>
                                </div>
                                <blockquote className="blockquote mb-0">
                                    <p>"Incredibly fast and professional service. The team cleared out my garage in under an hour. Highly recommend!"</p>
                                </blockquote>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={6} lg={4} className="mb-4">
                        <Card className="h-100">
                            <Card.Body>
                                <div className="d-flex align-items-center mb-3">
                                    <Image src="https://i.pravatar.cc/50?img=2" roundedCircle className="me-3" />
                                    <div>
                                        <Card.Title className="mb-0">Mike R.</Card.Title>
                                        <div className="text-warning">
                                            <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                                        </div>
                                    </div>
                                </div>
                                <blockquote className="blockquote mb-0">
                                    <p>"Booking was so easy, and the price was very fair. EasyTrashOut is now my go-to for any junk removal."</p>
                                </blockquote>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={6} lg={4} className="mb-4">
                        <Card className="h-100">
                            <Card.Body>
                                <div className="d-flex align-items-center mb-3">
                                    <Image src="https://i.pravatar.cc/50?img=3" roundedCircle className="me-3" />
                                    <div>
                                        <Card.Title className="mb-0">Emily C.</Card.Title>
                                        <div className="text-warning">
                                            <FaStar /><FaStar /><FaStar /><FaStar /><FaRegStar />
                                        </div>
                                    </div>
                                </div>
                                <blockquote className="blockquote mb-0">
                                    <p>"They were courteous and efficient. I was so relieved to finally get rid of my old mattress."</p>
                                </blockquote>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>

            {/* 6. Footer */}
            <footer className="py-4 bg-dark text-white text-center">
                <Container>
                    <p className="mb-0">&copy; {new Date().getFullYear()} EasyTrashOut.com. All Rights Reserved.</p>
                </Container>
            </footer>
        </>
    );
};

export default EasyTrashOutLandingPage_10_06_2025;